import React, { Component } from "react";
import {Form, Button, FormGroup, FormControl, FormLabel } from "react-bootstrap";
import {errorExtract} from "../database/apiMethods"
import {ResetCode, apiUpdatePwd} from '../Login/ResetCode'
import { isplausibleEmail } from "../Edit/validators";
import {EmailInput, PasswordInput, RepeatPasswordInput} from '../Login/FormInputs';
import BannerMessage from '../Login/Banner'

import "./Account.css";

export default class Changepassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      confirmpassword: "",
      email: "",
      resetcode: "",
      passwordStatusShown: false,
      bannerMsg: "",
      bannerShown: false,
      bannerStyle: "alert-danger",
      apiPending: false,
    };
    this.closeAlert = this.closeAlert.bind(this);
    this.closeBanner = this.closeBanner.bind(this)
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();
    document.body.style.cursor = "wait";
    this.setState ({apiPending: true });
    const st = this.state;
    const resp = await apiUpdatePwd(st.email, st.password, st.resetcode)
    //const resp = new Error ("I'm testing here")
    const msg = errorExtract (resp);
    const problem = resp instanceof Error || (msg?.length ?? false);
    this.setState ({bannerShown: problem, bannerMsg: msg, passwordStatusShown: !problem, apiPending: false})
    document.body.style.cursor = "default";
  }

  closeBanner() {
    this.setState({bannerShown: false})
  }

  closeAlert () {
    this.setState({passwordStatusShown: false});
  }
  
  loginButtonDisabled () {
    return !this.validateForm() || this.state.apiPending;
  }

  validateForm() {
    if (isplausibleEmail (this.state.email)) {
      if (this.state.resetcode.length > 5) {
        return this.state.password.length > 5 &&
        (this.state.password.localeCompare(this.state.confirmpassword) === 0);
      }
    } 
    return false;
  }

  passwordStatus() {
    if (this.state.passwordStatusShown) {
      const displayMsg = "Password Changed";
      const displayClass = "alert alert-dismissible alert-success create-fail";
      return (
      <div className={displayClass}>
      <button type="button" className="close" onClick={this.closeAlert} data-dismiss="alert">&times;</button>
        {displayMsg}
      </div>);
    }
    else return null;
  }

  handleReset = async event => {
    const resp = await ResetCode(this.props, this.props.userLogin)
    this.setState ({...resp, bannerShown: true})
  }

  render() {
    const pwdOpt={"autoComplete":"new-password"}
    return (
      <div className="pwd-container">
        <Form className="change-pwd" onSubmit={this.handleSubmit}>
            <div className="formtitle formcenter formintro">Change password</div>
            <h6><div className="number-circle">1</div>
              You need a reset code before changing your password.</h6>

            <Button className="all-button reset-pwd-button" type="button" onClick={this.handleReset}>
              Email Password Reset Code</Button>
            
            <BannerMessage msg={this.state.bannerMsg} show={this.state.bannerShown} 
                      variant={this.state.bannerStyle} close={this.closeBanner} />

            <h6><div className="number-circle">2</div>
              Fill in the form to change your password.</h6>

            <EmailInput onChange={this.handleChange} value={this.state.email} autoFocus />
            <FormGroup controlId="resetcode" >
            <FormLabel className="formLabel">The reset code we sent</FormLabel>
            <FormControl 
              value={this.state.resetcode}
              onChange={this.handleChange}
              type="text"
            />
          </FormGroup>
          <PasswordInput onChange={this.handleChange} value={this.state.password} options={pwdOpt}/>
          <RepeatPasswordInput onChange={this.handleChange} value={this.state.confirmpassword} />

          <Button className="all-button update-btn w-100"  disabled={this.loginButtonDisabled()} type="submit">
                Update password
            </Button>
        </Form>
        {this.passwordStatus()}
          <div className="formcenter link" onClick={this.props.redirect}>
            Ok, thanks, back to the site list</div>
        </div>
    );
  }
}
